import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const SecessionModalContent = ({ content, onClose, isAgree }) => {
  const navigate = useNavigate();
  const navigation = () => {
    if (isAgree) {
      navigate("/login");
    }
    return;
  };
  return (
    <ContentWrapper>
      <ContentText>{content}</ContentText>
      <ButtonWrapper>
        <CertButton
          onClick={() => {
            onClose();
            navigation();
          }}
        >
          확인
        </CertButton>
      </ButtonWrapper>
    </ContentWrapper>
  );
};

const ContentWrapper = styled.div`
  padding: 28px 16px;
  text-align: center;
  width: 240px;
`;

const ContentText = styled.p`
  font-size: 0.875rem;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
`;

const CertButton = styled.button`
  width: 120px;
  padding: 10px 0;
  font-size: 0.875rem;
  border-radius: 4px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  background-color: #ff7a00;
  color: #ffffff;
`;

export default SecessionModalContent;
